// Auto-generated file - DO NOT EDIT
// Generated at build time by scripts/generate-version.js

export const VERSION = {
  gitCommit: 'f3f21fb969246e9f477918a6087f09c8a7778daa',
  gitCommitShort: 'f3f21fb',
  gitBranch: 'main',
  buildTime: '2026-08-04T13:39:11.270Z',
} as const;

export type VersionInfo = typeof VERSION;
export default VERSION;
